// @flow

/**
 * `html-to-image` rejects the whole capture when a single image inside it
 * fails to embed, so the download button ends up doing nothing at all and the
 * only trace is a bare `error` event. These helpers name the image involved
 * and let the capture finish without it.
 */

function describeImage(image: HTMLImageElement) {
  return {
    alt: image.alt,
    className: image.className,
    complete: image.complete,
    naturalWidth: image.naturalWidth,
    src: String(image.src).slice(0, 100),
  };
}

/**
 * Logs every image inside the node about to be captured, so a failure can be
 * matched against what was actually there when the button was pressed.
 */
export function logCaptureImages(node: ?HTMLElement, label: string) {
  if (!node) return;

  const images = Array.from(node.querySelectorAll('img'));
  console.log(`[${label}] images in capture (${images.length})`, {
    images: images.map(describeImage),
  });
}

/**
 * Handler for `html-to-image`'s `onImageErrorHandler`: reports which image
 * could not be embedded and resolves, so the rest of the capture still makes
 * it into the PNG instead of the whole download failing.
 */
export function buildImageErrorHandler(label: string) {
  return (event: any) => {
    const image = event && event.target;
    console.log(
      `[${label}] image could not be embedded, skipping it`,
      image ? describeImage(image) : event
    );
  };
}
